export default __webpack_public_path__ + "static/media/guardian_symbol_white_transparent.a3310da3.png";